import { ArticleType, CreditCardArticleDetails } from '@nemuru-eng/js-api-client';

import { Item } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/entities/Item';
import { CreditCardNameMap } from '@/components/modules/Application/IberiaCards/_shared/maps/CreditCardName.map';
import { CreditCardFormItem } from '@/components/modules/Application/IberiaCards/_shared/schemas/CreditCardFormItem.schema';

// TODO: Decouple from IBC

export class CreditCardItem extends Item<CreditCardFormItem> {
  constructor(data: CreditCardFormItem) {
    super(data);
  }

  protected isCompleted(): boolean {
    return !!this.data.cardTypeName;
  }

  public isItemCompleted(): boolean {
    return (
      !!this.data.type && !!this.data.category && !!this.data.description && !!this.data.units && this.isCompleted()
    );
  }

  protected toForm(): CreditCardFormItem {
    return {
      ...this.toMinimalFormItem(),
      type: ArticleType.CREDIT_CARD,
      cardTypeName: this.data.cardTypeName,
    };
  }

  public static fromOrderLineDto(units: number, article: CreditCardArticleDetails): CreditCardItem {
    const formData: CreditCardFormItem = {
      // Minimal form item fields
      units: units.toString(),
      vat: '0', // FIXME: Default VAT
      price: article.price.amount.toFixed(2).toString(),
      category: article.category,

      // ArticleType-specific fields
      type: ArticleType.CREDIT_CARD,
      description: article.description || '',
      cardTypeName: CreditCardNameMap.toName(article.configuration.cardType),
    };

    return new CreditCardItem(formData);
  }

  protected toDto(): object {
    // TODO: make these dynamic
    return {
      name: this.data.cardTypeName,
      providerName: 'iberia_cards',
      configuration: {
        ...CreditCardNameMap.toTypeConfiguration(this.data.cardTypeName),
        corporateGroup: 0,
        customerType: 'iberia-cards-stand',
        marketingCampaign: 'iberia-cards-stand',
        applicationOrigin: 0,
        channel: 'iberia-cards-stand',
      },
    };
  }
}
